import { makeAutoObservable } from "mobx";

export default class AdministrationStore {
	constructor() {
		this._meetings = [];
		this._verbalProcedure = [];
		this._specialCommitteesMeets = [];

		this._meetingsPage = 1;
		this._verbalProcedurePage = 1;
		this._specialCommitteesMeetsPage = 1;

		this._meetingsTotalCount = 0;
		this._verbalProcedureTotalCount = 0;
		this._specialCommitteesMeetsTotalCount = 0;

		this._meetingsLimit = 10;
		this._verbalProcedureLimit = 10;
		this._specialCommitteesMeetsLimit = 10;

		makeAutoObservable(this);
	}

	setMeetings(meetings) {
		this._meetings = meetings;
	}
	get meetings() {
		return this._meetings;
	}

	setVerbalProcedure(verbalProcedure) {
		this._verbalProcedure = verbalProcedure;
	}
	get verbalProcedure() {
		return this._verbalProcedure;
	}

	setSpecialCommitteesMeets(specialCommitteesMeets) {
		this._specialCommitteesMeets = specialCommitteesMeets;
	}
	get specialCommitteesMeets() {
		return this._specialCommitteesMeets;
	}

	setMeetingsPage(page) {
		this._meetingsPage = page;
	}

	get meetingsPage() {
		return this._meetingsPage;
	}

	setVerbalProcedurePage(page) {
		this._verbalProcedurePage = page;
	}

	get verbalProcedurePage() {
		return this._verbalProcedurePage;
	}

	setSpecialCommitteesMeetsPage(page) {
		this._specialCommitteesMeetsPage = page;
	}

	get specialCommitteesMeetsPage() {
		return this._specialCommitteesMeetsPage;
	}

	setMeetingsTotalCount(count) {
		this._meetingsTotalCount = count;
	}

	get meetingsTotalCount() {
		return this._meetingsTotalCount;
	}

	setVerbalProcedureTotalCount(count) {
		this._verbalProcedureTotalCount = count;
	}

	get verbalProcedureTotalCount() {
		return this._verbalProcedureTotalCount;
	}

	setSpecialCommitteesMeetsTotalCount(count) {
		this._specialCommitteesMeetsTotalCount = count;
	}

	get specialCommitteesMeetsTotalCount() {
		return this._specialCommitteesMeetsTotalCount;
	}

	setMeetingsLimit(limit) {
		this._meetingsLimit = limit;
	}

	get meetingsLimit() {
		return this._meetingsLimit;
	}

	setVerbalProcedureLimit(limit) {
		this._verbalProcedureLimit = limit;
	}

	get verbalProcedureLimit() {
		return this._verbalProcedureLimit;
	}

	setSpecialCommitteesMeetsLimit(limit) {
		this._specialCommitteesMeetsLimit = limit;
	}

	get specialCommitteesMeetsLimit() {
		return this._specialCommitteesMeetsLimit;
	}
}
